export function getLinkToVentHome(ventId: string): string {
  return `/console/eventhome/event/${ventId}`;
}
export function getPersonalVentLink(guestGuid: string): string {
  return `/pel/${guestGuid}`;
}
export function getLinkToConsole(): string {
  return `/console`;
}
export function getLinkToVentConfig(ventId: string): string {
  return `/console/eventconfig/event/${ventId}`;
}
export function getLinkToVentGuests(ventId: string): string {
  return `/console/guests/event/${ventId}`;
}
export function getLinkToVentEmailTemplates(ventId: string): string {
  return `/console/emailTemplates/event/${ventId}`;
}
export function getLinkToVentActivities(ventId: string): string {
  return `/console/eventactivities/event/${ventId}`;
}
export function getLinkToVentCustomFields(ventId: string): string {
  return `/console/customfields/event/${ventId}`;
}
export function getLinkToVentGuest(ventId: string, guestId: string): string {
  return `/console/guest/event/${ventId}/guest/${guestId}`;
}
export function getLinkToMessageGuest(ventId: string, guestId: string): string {
  return `/console/guests/event/${ventId}?messageguestid=${guestId}`;
}
export function getLinkToSettings(): string {
  return `/console/settings`;
}
